(function () {
  // Helper: simple email validation
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());
  }

  function closeAllForms(exceptId) {
    document.querySelectorAll(".gdpr-form").forEach((form) => {
      if (!exceptId || form.id !== exceptId) form.style.display = "none";
    });
  }

  function toggleForm(targetId) {
    const form = document.getElementById(targetId);
    if (!form) return;

    const isOpen = form.style.display === "block";
    closeAllForms(targetId);
    form.style.display = isOpen ? "none" : "block";
  }

  function submitRequest(buttonEl) {
    const form = buttonEl.closest(".gdpr-form");
    if (!form) return;

    const input = form.querySelector('input[type="email"]');
    const error = form.querySelector(".gdpr-error");
    const email = input ? input.value.trim() : "";

    if (!isValidEmail(email)) {
      if (error) error.style.display = "block";
      if (input) input.focus();
      return;
    }
    if (error) error.style.display = "none";

    // What happens on submit:
    // If you later connect an app/API, replace this block with fetch().
    const requestType = buttonEl.getAttribute("data-type") || "GDPR ΑΙΤΗΜΑ";
    const subject = encodeURIComponent(`[GDPR] ${requestType}`);
    const body = encodeURIComponent(
      `Γεια σας,\n\nΘα ήθελα να υποβάλω αίτημα GDPR.\n\nΤύπος αιτήματος: ${requestType}\nEmail λογαριασμού: ${email}\n\nΕυχαριστώ.`
    );

    // Open email client to support@
    window.location.href = `mailto:support@candelinas.com?subject=${subject}&body=${body}`;
  }

  // ✅ Event delegation: works even if Shopify re-renders content
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".gdpr-btn");
    if (btn) {
      const targetId = btn.getAttribute("data-target");
      if (targetId) toggleForm(targetId);
      return;
    }

    const submit = e.target.closest(".gdpr-submit");
    if (submit) {
      submitRequest(submit);
      return;
    }
  });

  // Optional: hide error when user types
  document.addEventListener("input", function (e) {
    const input = e.target.closest(".gdpr-form input[type='email']");
    if (!input) return;
    const form = input.closest(".gdpr-form");
    const error = form ? form.querySelector(".gdpr-error") : null;
    if (error) error.style.display = "none";
  });

  // Debug (remove later)
  console.log("[GDPR] script loaded. Buttons found:", document.querySelectorAll(".gdpr-btn").length);
})();
